import { render, staticRenderFns } from "./sku-form.vue?vue&type=template&id=72bf7fd4&scoped=true"
import script from "./sku-form.vue?vue&type=script&lang=js"
export * from "./sku-form.vue?vue&type=script&lang=js"
import style0 from "./sku-form.vue?vue&type=style&index=0&id=72bf7fd4&prod&lang=scss&scoped=true"
import style1 from "./sku-form.vue?vue&type=style&index=1&id=72bf7fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf7fd4",
  null
  
)

export default component.exports